import { createContext, useContext } from 'react'

/**
 * The currency every amount in a capex plan is expressed in, resolved by the
 * backend from the plan asset's jurisdiction (`capex_plans.currency`).
 *
 * A context rather than a prop because the amounts are rendered six levels down
 * — KPI strip, budget footer, package rows, quote dialog — and threading a
 * currency through every one of them would guarantee that the next component
 * forgets it and silently reverts to the euro this replaces.
 *
 * `null` means the plan's country is unknown to the platform: render the
 * figures bare. A wrong symbol misleads; a missing one merely under-informs.
 */
const CapexCurrencyContext = createContext<string | null>(null)

export const CapexCurrencyProvider = CapexCurrencyContext.Provider

export function useCapexCurrency(): string | null {
  return useContext(CapexCurrencyContext)
}
